export default "__VITE_ASSET__BpoJe_ZI__"